export default [
  {
    menuItems: [
      {label: 'Trang chủ', icon: 'far fa-home', to: '/', permission: null},
      {label: 'Cấu hình kho', icon: 'fas fa-warehouse', to: '/config/warehouse', permission: 'config_warehouse_shop_ff_view'},
      // {label: 'Quản lý lỗi', icon: 'far fa-bug', to: '/error-request', permission: 'error_request_view'},
      {label: 'Tiện ích hỗ trợ theo shop', icon: 'fas fa-user-headset', to: '/support-shop', permission: 'support_shop_view'},
      {
        label: 'Quản lý đơn hàng',
        icon: 'far fa-cubes',
        menuItems: [
          {label: 'Đơn hàng', icon: 'fas fa-box-alt', to: '/package', permission: 'package_view'},
          {label: 'Xuất đơn hàng', icon: 'fas fa-shipping-timed', to: '/package/export', permission: 'package_view'},
          {label: 'Quản lý trạng thái đơn hàng', icon: 'fas fa-box-full', to: '/package/mng', permission: 'package_view'},
        ]
      },
      {
        label: 'Quản lý sản phẩm',
        icon: 'far fa-barcode-read',
        menuItems: [
          {label: 'Xóa sản phẩm', icon: 'fas fa-trash-alt', to: '/products/delete', permission: 'product_delete'},
          {label: 'Cân chỉnh SL hàng tồn kho', icon: 'fas fa-recycle', to: '/products/inventory', permission: 'product_detail_view'},
        ]
      },
      {
        label: 'Báo cáo',
        icon: 'far fa-file-chart-line',
        menuItems: [
          {label: 'Báo cáo kiểm kho', icon: 'fas fa-warehouse-alt', to: '/report/inventory', permission: 'report_export'},
          {label: 'Báo cáo tồn bưu cục', icon: 'fad fa-truck-moving', to: '/report/station/inventory', permission: 'report_export'},
        ]
      }
    ]
  },
  {
    label: 'Moshop',
    menuItems: [
      {label: 'Cấu hình tính năng cho shop', icon: 'fal fa-dice-d20', to: '/moshop/shop-feature', permission: 'moshop_shop_feature_view'},
    ]
  },
  {
    label: 'Administration',
    menuItems: [
      {
        label: 'Quản lý phân quyền',
        icon: 'far fa-shield-alt',
        to: null,
        permission: null,
        menuItems: [
          {label: 'Phân quyền user', icon: 'fas fa-user-tag', to: '/admin/permission/role-user', permission: 'user_role_view'},
          {label: 'Vai trò', icon: 'fas fa-tags', to: '/admin/permission/roles', permission: 'roles_view'},
          {label: 'Tài nguyên', icon: 'fas fa-cubes', to: '/admin/permission/resources', permission: 'resources_view'},
          {label: 'Hành động', icon: 'far fa-construction', to: '/admin/permission/actions', permission: 'actions_view'},
          {label: 'Quyền', icon: 'far fa-key', to: '/admin/permission/permission', permission: 'permission_view'},
        ]
      },
      {label: 'Quản lý mã xác thực', icon: 'fal fa-dice-d20', to: '/admin/authenticate', permission: 'authenticate_view'},
      // {label: 'Cấu hình hệ thống', icon: 'fas fa-cogs', to: '/admin/system-config-properties', permission: 'system_config_properties_view'},

      {
        label: 'Cấu hình',
        icon: 'fas fa-cogs',
        to: null,
        permission: null,
        menuItems: [
          {label: 'Cấu hình hệ thống', icon: 'fas fa-cog', to: '/admin/system-config-properties', permission: 'system_config_properties_view'},
          {label: 'Cấu hình service', icon: 'fab fa-ubuntu', to: '/admin/system-config', permission: 'system_config_properties_view'},
        ]
      }

    ]
  },

]